import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { ChildrenPropType } from '../../services/proptypes';
var propTypes = {
  totalNumberOfItems: PropTypes.number.isRequired,
  autoScroll: PropTypes.bool,
  autoScrollTime: PropTypes.number,
  numberOfDisplayItems: PropTypes.number,
  children: ChildrenPropType.isRequired
};
var defaultProps = {
  autoScroll: false,
  autoScrollTime: 5000,
  numberOfDisplayItems: 3
};

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Carousel, _React$Component);

  function Carousel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      currentIndex: 0
    };
    _this.autoScrollTimer = null;
    _this.getDisplayItemIndices = _this.getDisplayItemIndices.bind(_assertThisInitialized(_this));
    _this.changeCurrentIndex = _this.changeCurrentIndex.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.startAutoScrollTimerInterval();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearAutoScrollTimerInterval();
  };

  _proto.getDisplayItemIndices = function getDisplayItemIndices() {
    var _this$props = this.props,
        numberOfDisplayItems = _this$props.numberOfDisplayItems,
        totalNumberOfItems = _this$props.totalNumberOfItems;
    var currentIndex = this.state.currentIndex;
    var displayIndices = new Array(numberOfDisplayItems).fill(currentIndex).map(function (i, index) {
      return (i + index) % totalNumberOfItems;
    });
    return displayIndices;
  };

  _proto.setCurrentIndex = function setCurrentIndex(index, resetInterval) {
    if (resetInterval === void 0) {
      resetInterval = false;
    }

    var totalNumberOfItems = this.props.totalNumberOfItems;

    if (resetInterval) {
      // to avoid moving to the next image right just after the user clicked on a indicator
      this.startAutoScrollTimerInterval();
    }

    this.setState({
      currentIndex: index % totalNumberOfItems
    });
  };

  _proto.startAutoScrollTimerInterval = function startAutoScrollTimerInterval() {
    var _this2 = this;

    var _this$props2 = this.props,
        autoScroll = _this$props2.autoScroll,
        autoScrollTime = _this$props2.autoScrollTime,
        totalNumberOfItems = _this$props2.totalNumberOfItems;
    this.clearAutoScrollTimerInterval();

    if (autoScroll && totalNumberOfItems > 1) {
      this.autoScrollTimer = setInterval(function () {
        return _this2.incrementCurrentIndex();
      }, autoScrollTime);
    }
  };

  _proto.clearAutoScrollTimerInterval = function clearAutoScrollTimerInterval() {
    if (this.autoScrollTimer) {
      clearInterval(this.autoScrollTimer);
      this.autoScrollTimer = null;
    }
  };

  _proto.changeCurrentIndex = function changeCurrentIndex(index) {
    var totalNumberOfItems = this.props.totalNumberOfItems;

    if (index < 0) {
      this.setCurrentIndex(totalNumberOfItems - 1, true);
    } else if (index === totalNumberOfItems) {
      this.setCurrentIndex(0, true);
    } else {
      this.setCurrentIndex(index, true);
    }
  };

  _proto.incrementCurrentIndex = function incrementCurrentIndex() {
    var currentIndex = this.state.currentIndex;
    this.setCurrentIndex(currentIndex + 1);
  };

  _proto.render = function render() {
    var currentIndex = this.state.currentIndex;
    var children = this.props.children;
    var childProps = {
      currentIndex: currentIndex,
      getDisplayItemIndices: this.getDisplayItemIndices,
      changeCurrentIndex: this.changeCurrentIndex
    };
    return children(childProps);
  };

  return Carousel;
}(React.Component);

export { Carousel as default };
Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;